import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Rows } from '@/components/layout'
import { Text } from '@/components/common'

import styles from './IconInfoBlock.module.scss'

const IconInfoBlock = ({ img, title, children, wide }) => (
  <div className={`${styles.wrapper} ${wide ? styles.wrapperwide : styles.wrappernormal}`}>
    <div className={styles.icon}>
      <Image
        alt={title}
        height="48"
        src={img}
        width="48"
      />
    </div>
    <div className={styles.content}>
      <Text.H3 className={styles.title}>{title}</Text.H3>
      <Rows>{children}</Rows>
    </div>
  </div>
)

IconInfoBlock.propTypes = {
  children: PropTypes.node.isRequired,
  img: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  wide: PropTypes.bool,
}

export default IconInfoBlock
